import React from "react";
import { questionGuideData, examplePlanningQuestion } from "./questionGuideData";

const QuestionGuide = () => {
  return (
    <div className="alert alert-info mb-4">
      <h5 className="font-weight-bold mb-2">How to Ask Effective Questions</h5>
      <p className="mb-3">To get the most useful insights from the SQL RAG system, structure your questions with these elements:</p>
      <ol className="pl-3 mb-3">
        {questionGuideData.map((item, index) => (
          <li className="mb-2" key={index}>
            <strong>{item.title}</strong> {item.description && item.description}
            <div className="bg-light p-2 rounded mt-1 small text-black">
              ❌ {item.badExample}<br/>
              ✅ {item.goodExample}
            </div>
          </li>
        ))}
      </ol>
      <div className="bg-light p-2 rounded text-black">
        <strong>Example for new product planning:</strong><br/>
        {examplePlanningQuestion}
      </div>
    </div>
  );
};

export default QuestionGuide;
